import en from "wording/en_active.json";

export const wording = {
	en,
};
